import React, { forwardRef } from 'react';
import Input from './Input';
import dayjs from 'dayjs';

interface DatePickerComponentProps {
	label?: string;
	value?: any;
	onChange?: (date: any) => void;
	disableFuture?: boolean;
	disablePast?: boolean;
	disabled?: boolean;
	onError?: (error: any) => void;
	error?: boolean;
	helperText?: string;
	required?: boolean;
	fullWidth?: boolean;
	placeholder?: string;
}

const DatePickerComponent = forwardRef<
	HTMLDivElement,
	DatePickerComponentProps
>(
	(
		{
			label,
			value,
			onChange,
			disableFuture,
			disablePast,
			disabled,
			onError,
			error,
			helperText,
			required,
			fullWidth,
			placeholder,
		},
		ref
	) => {
		const handleDateChange = (
			event: React.ChangeEvent<HTMLInputElement>
		) => {
			const dateValue = event.target.value;
			if (onChange) {
				// Convert to dayjs object if there's a value, otherwise pass null
				const date = dateValue ? dayjs(dateValue) : null;
				onChange(date);
			}
		};

		// Convert value to YYYY-MM-DD format for input[type="date"]
		const inputValue = value
			? dayjs.isDayjs(value)
				? value.format('YYYY-MM-DD')
				: dayjs(value).format('YYYY-MM-DD')
			: '';

		// Calculate min and max dates based on disableFuture/disablePast
		const today = dayjs().format('YYYY-MM-DD');
		const minDate = disablePast ? today : undefined;
		const maxDate = disableFuture ? today : undefined;

		return (
			<Input
				type="date"
				label={label}
				value={inputValue}
				onChange={handleDateChange}
				disabled={disabled}
				error={error}
				helperText={helperText}
				required={required}
				fullWidth={fullWidth}
				placeholder={placeholder}
				inputProps={{
					min: minDate,
					max: maxDate,
				}}
				ref={ref}
			/>
		);
	}
);

export default DatePickerComponent;
